import React from 'react';
import { LoginCard } from '../components/auth/LoginCard';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
interface LandingPageProps {
  onLogin: () => void;
}
export function LandingPage({
  onLogin
}: LandingPageProps) {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-417">
      <Header isAuthenticated={false} onLogout={() => {}} data-id="element-418" />
      <main className="flex-grow" data-id="element-419">
        <div className="container mx-auto px-4 py-12 md:py-20" data-id="element-420">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-421">
            <div className="w-full md:w-1/2 space-y-6" data-id="element-422">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1F36]" data-id="element-423">
                EthBridge Enterprise portal
              </h1>
              <p className="text-lg text-gray-600" data-id="element-424">
                Comprehensive solution for financial institutions to monitor
                transactions, manage users, and generate detailed reports in
                real-time.
              </p>
            </div>
            <div className="w-full md:w-1/2 max-w-md" data-id="element-425">
              <LoginCard onLogin={onLogin} data-id="element-426" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-427" />
    </div>;
}